import {
  useDailyEvent,
  useScreenShare
} from '@daily-co/daily-react';
import { useCallback, useState } from 'react';

import AudioTranscriberSeeder from '../MicStatus/AudioTranscriberSeeder';
import TranscricaoWSSender from '../MicStatus/TranscricaoWebSocketSender';
import StateDebugPanel from '../StateDebugPanel/StateDebugPanel';
import SlideContent from '../Tile/SlideContent';
import UserMediaError from '../UserMediaError/UserMediaError';
import './Call.css';

export default function Call() {
  /* If a participant runs into a getUserMedia() error, we need to warn them. */
  const [getUserMediaError, setGetUserMediaError] = useState(false);

  /* We can use the useDailyEvent() hook to listen for daily-js events. Here's a full list
   * of all events: https://docs.daily.co/reference/daily-js/events */
  useDailyEvent(
    'camera-error',
    useCallback(() => {
      setGetUserMediaError(true);
    }, []),
  );

  /* This is for displaying remote participants: this includes other humans, but also screen shares. */
  const { screens } = useScreenShare();

  const renderCallScreen = () => (
    <div className={screens.length > 0 ? 'is-screenshare' : 'call'} style={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* Audio Transcriber Seeder ativo */}
      <AudioTranscriberSeeder />
      {/* WebSocket Sender para transcrições */}
      <TranscricaoWSSender />
      {/* State Debug Panel */}
      <StateDebugPanel />
      {/* Camada de fundo: SlideTile */}
      <SlideContent />
    </div>
  );

  return getUserMediaError ? <UserMediaError /> : renderCallScreen();
}
